import type { PageLoad } from './$types';
import type { PageData } from '$lib/metadataTypes/MetaTypes';

export const load: PageLoad = async ({ parent }): Promise<PageData> => {
  const { site, category } = await parent(); // parent() = CategoryData

  return {
    site,
    category,
    page: {
			title: "Projections and Indentation",
description: "Understand how indentation in Freon projections affects the visual layout of text and nested elements in the editor, including how least indentation and incremental indentation are handled.",
tags: [ "projections", "indentation", "editor layout", "text alignment", "whitespace handling", "projection syntax", "Freon", "DSL development"] ,
modifiedTime: "2025-11-07T17:39:02.346Z",
publishedTime: "2025-11-07T17:20:18.610Z"
    }
  };
};